module.exports = __webpack_public_path__ + "img/zjjh_2_black.a316e3d6.png";